module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1